import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { Colour, Tile, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { useNavigate } from 'react-router';
import { IssueEntryType } from '../AccountIssuesTypes';

function LockedMailIssueEntry(props: IssueEntryType) {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<Tile
			onClick={() =>
				navigate('./mail/locked-items', {
					state: { folderId: 9, includeFolderAssigned: true },
				})
			}
			title={t('accountIssues.labels.lockedItems')}
			description={t('accountIssues.counts.item', {
				count: props.count,
			})}
			icon={faLock}
			isHorizontal
			colour={Colour.Alert}
		/>
	);
}

export { LockedMailIssueEntry };
